import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MoveDetails from "../pages/move_info/MoveDetails";
import PropertyInfo from "../pages/property_info/PropertyInfo";
import AddInventory from "../pages/inventory/AddInventory";
import Summary from "../pages/summary/Summary";
import Login from "../pages/login/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import SkipConfirmation from "../pages/confirmation/skipConfirmation";
import Confirmation from "../pages/confirmation/Confirmation";
import { useSelector } from "react-redux";
import { MyProfile } from "../pages/dashboard/MyProfile";
import { PaymentCheckout } from "../pages/payment/PaymentCheckout";
import { PaymentSuccess } from "../pages/payment/PaymentSuccess";
import { VendorRatings } from "../pages/ratings/VendorRatings";
import EditInventory from "../pages/dashboard/EditInventory";
import { StorageMoveInfo } from "../pages/storage_services/StorageMoveInfo";
import AddStorageInventory from "../pages/storage_services/AddStorageInventory";
import { StorageSummary } from "../pages/storage_services/StorageSummary";

export const commonRoutesList = [
  {
    path: "/storage-services/get-quote/items-info",
    component: <AddStorageInventory />,
  },
  {
    path: "/storage-services/get-quote/summary",
    component: <StorageSummary />,
  },
  {
    path: "/storage-services/get-quote",
    component: <StorageMoveInfo />,
  },
  {
    path: "/packers-and-movers-relocation-services/get-quote",
    component: <MoveDetails />,
  },
  {
    path: "/packers-and-movers-relocation-services/get-quote/property-info",
    component: <PropertyInfo />,
  },
  {
    path: "/packers-and-movers-relocation-services/get-quote/items-info",
    component: <AddInventory />,
  },
  {
    path: "/packers-and-movers-relocation-services/get-quote/summary",
    component: <Summary />,
  },
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/",
    component: <MoveDetails />,
  },
  // {
  //   path: "/",
  //   component: <Login />,
  // },
];


export const protectedRoutesList = [
  ...commonRoutesList,
  {
    path: "/packers-and-movers-relocation-services/get-quote/confirmation/:serviceType/:estimateId",
    component: <Confirmation />,
  },
  {
    path: "/packers-and-movers-relocation-services/get-quote/skip-confirmation/:estimateId",
    component: <SkipConfirmation />,
  },
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/my-profile",
    component: <MyProfile />,
  },
  {
    path: "/payment-checkout/:estimateId/:vendorId",
    component: <PaymentCheckout />,
  },
  {
    path: "/payment-successful",
    component: <PaymentSuccess />,
  },
  {
    path: "/dashboard/packers-and-movers-vendor/write-review/:estimateId/:vendorId",
    component: <VendorRatings />,
  },
  {
    path: "/dashboard/edit-inventory/:estimateId/:propertySize/:updateType",
    component: <EditInventory />,
  },
];

export default function Routes() {
  const { loggedIn } = useSelector((state) => state.userInfo);
  // console.log("loggedIn state", loggedIn);
  // sessionStorage.getItem("isUserLoggedIn")
  if (loggedIn === true) {
    const protectedRoutes = (
      <Router>
        <div>
          <Switch>
            {protectedRoutesList.map((route, index) => {
              return (
                <Route path={route.path} key={index} exact={true}>
                  {route.component}
                </Route>
              );
            })}
            <Route>
              <h1 class="text-center p-5 m-5">404 Not Found </h1>
            </Route>
          </Switch>
        </div>
      </Router>
    );
    return protectedRoutes;
  }
  const commonRoutes = (
    <Router>
      <div>
        <Switch>
          {commonRoutesList.map((route, index) => {
            return (
              <Route path={route.path} key={index} exact={true}>
                {route.component}
              </Route>
            );
          })}
          <Route>
            <h1 class="text-center p-5 m-5"> 404 Not Found </h1>
          </Route>
        </Switch>
      </div>
    </Router>
  );
  return commonRoutes;
}
